import { WarningNotice } from "web_myplann/Goals/Components/AmountSections/WarningNotice";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { formatNumber } from "web_myplann/Shared/Utils/numberFormatters";

type Props = {
	monthlyRent: number;
	statePension: number;
	currencySuffix: string;
};

export const StatePensionCoversAllNotice: React.FC<Props> = ({
	monthlyRent,
	statePension,
	currencySuffix,
}) => {
	const { t } = useResource();

	return (
		<WarningNotice
			title={t(Resources.Goals.Form.Notices.statePensionCoversAllTitle)}
			description={t(
				Resources.Goals.Form.Notices.statePensionCoversAllDescription,
				{
					desired: `${formatNumber(monthlyRent)} ${currencySuffix}`,
					state: `${formatNumber(statePension)} ${currencySuffix}`,
				},
			)}
		/>
	);
};
